import ProductLabel from './productLabel.vue'
import Product from './product.vue'


export default {
	ProductLabel,
	Product,
}



// WEBPACK FOOTER //
// ./src/views/product/index.js